import React from "react";
import "./DetailedTechnique.scss";

const Technique = ({className, technique, empty, onClick, disabled, baseImgURL}) => {
  if (!technique) {
    return <div>Technique not found</div>;
  }

  let holds = [];
  if (technique.hold && technique.hold > 0) {
    holds = Array.from({length: technique.hold}).map((v, i) => <span key={i} className={`hold turn${i+1}`}></span>)
  }

  let synergyEffect = {dmg: technique.damage, sta: technique.cost, priority: technique.priority, effects: [], type: technique.type}
  if (technique.synergy_effect) {
    const splitSynEffects = technique.synergy_effect.split(";", -1);
    splitSynEffects.forEach((synEffect) => {
      const splits = synEffect.split(":", -1);
      let modifier = 0;
      switch(splits[0]) {
        case "DMG":
          modifier = splits.length > 1 ? parseInt(splits[1]) : 0;
          if (synergyEffect.dmg) {
            synergyEffect.dmg = parseInt(synergyEffect.dmg) + modifier;
          } else {
            synergyEffect.dmg = modifier;
          }
          break;
        case "STA":
          modifier = splits.length > 1 ? parseInt(splits[1]) : 0;
          if (synergyEffect.sta) {
            synergyEffect.sta = parseInt(synergyEffect.sta) + modifier;
          } else {
            synergyEffect.sta = modifier;
          }
          break;
        case "PRIORITY":
          modifier = splits.length > 1 ? parseInt(splits[1]) : 0
          if (synergyEffect.priority) {
            synergyEffect.priority = parseInt(synergyEffect.priority) + modifier;
          } else {
            synergyEffect.priority = modifier;
          }
          break;
        default:
          break;
      }
    });
  }

  return (
    <div className={`detailed-technique-wrapper${className ? " " + className : ""} ${disabled ? "disabled": ""}`} onClick={!disabled ? () => onClick() : () => {}}>
      <div className={`detailed-technique ${!empty && technique.type ? technique.type.toLowerCase() : ""}`}>
        <div className="technique-type"><span className={`type ${technique.type ? technique.type.toLowerCase(): ""}`} /></div>
        <div className="technique-class"><img src={`${baseImgURL}/techniques/class/${technique.class ?technique.class.toLowerCase(): ""}.png`} alt={technique.class ? technique.class.toLowerCase() : ""}/></div>
        <div className="technique-inner">
          <span className="typing"></span>
          {holds}
          <div className="technique-info">
            <div className="name"><span>{technique.name}</span></div>
            <div className="description">{technique.description || "Temporary desription"}</div>
          </div>
          <div className="technique-stats">
            <div className="technique-numbers">
              <div className="technique-number damage">
                <div className="label">DMG</div>
                <div className="value">{technique.damage}</div>
              </div>
              <div className="technique-number cost">
                <div className="label">STA</div>
                <div className="value">{technique.cost}</div>
              </div>
            </div>
            <div className="technique-priority">
              <div className="title">Priority</div>
              <div className="value"><img src={`${baseImgURL}/techniques/priorities/${technique.priority}.png`} alt={`Priority ${technique.priority}`}/></div>
            </div>
          </div>
        </div>
      </div>
      {technique.synergy ? (
        <div className="synergy-technique-details">
          <div className="technique-synergy-plus"><span>+</span></div>
          <div className="technique-synergy"><span className={`type ${technique.synergy.toLowerCase()}`} /></div>
          <div className="description">{technique.synergy_description || "Temporary desription"}</div>
          <div className="technique-stats">
            <div className="technique-numbers">
              <div className="technique-number damage">
                <div className="label">DMG</div>
                <div className="value">{synergyEffect.dmg}</div>
              </div>
              <div className="technique-number cost">
                <div className="label">STA</div>
                <div className="value">{synergyEffect.sta}</div>
              </div>
            </div>
            <div className="technique-priority">
              <div className="title">Priority</div>
              <div className="value"><img src={`${baseImgURL}/techniques/priorities/${synergyEffect.priority}.png`} alt={`Priority ${synergyEffect.priority}`}/></div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Technique;
